module.exports = __webpack_public_path__ + "img/(1).495b8af4.png";